export default __webpack_public_path__ + "static/media/paint-palette.73fe2647.png";